module.exports = __webpack_public_path__ + "img/gabe-12.523f66b2.jpg";